var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ErrorIcon from "@mui/icons-material/Error";
import { ETeam, getRoleNightActionColor, } from "../../../../types";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
import { useAppDispatch, useAppSelector, useQuery } from "../../../../hooks";
import { selectMatchState, setMatchState } from "../../../../store/match";
import { computeNightResults, wakeUpRole } from "../../../../api";
import { Delimiter } from "../../../atoms/Delimiter";
import { ModalNew } from "../../../atoms/Modal/Modal";
import { DeskPool } from "../../DeskPool";
import { UnderLine } from "../../../atoms/UnderLine";
import * as api from "../../../../api/matches";
const nightActionsStyles = {
    padding: "48px 40px",
    alignItems: "flex-start",
    minWidth: "550px",
    height: "100%",
    display: "block",
    margin: "0 auto",
};
const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const Container = styled.div `
  display: flex;
  align-items: center;
`;
const ActionsContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const ActionText = styled.div `
  display: flex;
  font-size: 14px;
  line-height: 20px;
  color: #fff;

  span {
    font-weight: 700;
    color: ${({ textColor }) => textColor || "#899295"};
  }
`;
export function SelectRoleToWakeUp() {
    var _a, _b, _c;
    const { param: matchId } = useQuery("matchId");
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const roles = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.roles) || [];
    const actions = ((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.actions) || [];
    const readyToEndNight = ((_c = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _c === void 0 ? void 0 : _c.readyToEndNight) || false;
    const matchStateId = (matchState === null || matchState === void 0 ? void 0 : matchState.id) || "";
    const [isRequestSent, setRequestSent] = useState(false);
    const mafiaRoles = roles.filter((r) => r.team === ETeam.MAFIA);
    const civilianRoles = roles.filter((r) => r.team === ETeam.CIVILIANS);
    console.log(civilianRoles);
    const hasActiveRole = roles.find((r) => !r.wasPerformed && r.isPresented && r.canWakeUp) !==
        undefined;
    const onRoleWakeUp = (role) => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield wakeUpRole(role.role, matchStateId);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
        }
    });
    const changePhase = (id) => __awaiter(this, void 0, void 0, function* () {
        if (isRequestSent) {
            return;
        }
        try {
            setRequestSent(true);
            const result = yield computeNightResults(id);
            dispatch(setMatchState(result));
        }
        catch (err) {
            const result = yield api.getMatchState(id);
            dispatch(setMatchState(result));
            setRequestSent(false);
            errorHandler(err);
        }
    });
    const getPlayerName = (playerId) => {
        const target = matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
        return `${target === null || target === void 0 ? void 0 : target.player.gameName} (${target === null || target === void 0 ? void 0 : target.roleName})`;
    };
    const getButton = (role) => {
        const isPerformed = role.wasPerformed || !role.canWakeUp;
        return (_jsx(Button, Object.assign({ variant: isPerformed ? "outlined" : "contained", disabled: !role.canWakeUp, className: "wakeUpButton", onClick: () => onRoleWakeUp(role), size: "small" }, { children: role.text })));
    };
    // eslint-disable-next-line react/no-unstable-nested-components
    function NightActionsInfoModal({ onFouls }) {
        return (_jsx(ModalNew, Object.assign({ onClose: () => null }, { children: _jsxs(Paper, Object.assign({ sx: nightActionsStyles }, { children: [_jsxs(Wrapper, { children: [_jsxs(Typography, Object.assign({ variant: "h2" }, { children: ["\u041D\u043E\u0447\u044C \u2116", (matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) || 1] })), _jsx(Button, Object.assign({ className: "fouls", size: "medium", startIcon: _jsx(ErrorIcon, {}), onClick: () => onFouls === null || onFouls === void 0 ? void 0 : onFouls() }, { children: "\u0424\u043E\u043B\u044B" }))] }), _jsx(Delimiter, { top: "25px" }), roles.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u041C\u0430\u0444\u0438\u044F" })), _jsx(Delimiter, { top: "4px" }), mafiaRoles === null || mafiaRoles === void 0 ? void 0 : mafiaRoles.map((role) => (_jsxs(_Fragment, { children: [_jsx(Delimiter, { top: "12px" }), _jsxs(Wrapper, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: role.name })), getButton(role)] }, role.role), actions === null || actions === void 0 ? void 0 : actions.map((action, index) => action.role === role.role && (_jsxs(ActionsContainer, { children: [_jsx(Delimiter, { top: "10px" }), _jsx(Container, { children: _jsxs(ActionText, Object.assign({ textColor: getRoleNightActionColor(action.role) }, { children: [_jsxs("span", { children: [action.actionName, ":"] }), _jsx(Delimiter, { right: "8px" }), getPlayerName(action.targetId)] })) }), _jsx(Delimiter, { top: "24px" }), _jsx(UnderLine, { theme: { borderColor: "#517573" } })] }, action.role + index)))] }))), _jsx(Delimiter, { top: "34px" }), _jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0413\u043E\u0440\u043E\u0434" })), _jsx(Delimiter, { top: "4px" }), civilianRoles === null || civilianRoles === void 0 ? void 0 : civilianRoles.map((role) => {
                                var _a;
                                return (_jsxs(_Fragment, { children: [_jsx(Delimiter, { top: "12px" }), _jsxs(Wrapper, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: role.name })), _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: (_a = role.players[0]) === null || _a === void 0 ? void 0 : _a.player.gameName })), getButton(role)] }, role.role), actions.map((action, index) => action.role === role.role && (_jsxs(ActionsContainer, { children: [_jsx(Delimiter, { top: "10px" }), _jsxs(Container, { children: [_jsx(Delimiter, { right: "48px" }), _jsxs(ActionText, Object.assign({ textColor: getRoleNightActionColor(action.role) }, { children: [_jsxs("span", { children: [action.actionName, ":"] }), _jsx(Delimiter, { right: "8px" }), getPlayerName(action.targetId)] }))] }), _jsx(Delimiter, { top: "17px" }), _jsx(UnderLine, { theme: { borderColor: "#517573" } })] }, action.role + index)))] }));
                            })] })), _jsx(Delimiter, { top: "40px" })] })) })));
    }
    const onPlayerClickAction = null;
    const gameButtonState = {
        text: isRequestSent ? "Выполняется..." : "Завершить ночь",
        visible: readyToEndNight,
        onClick: () => changePhase(matchStateId),
        disabled: isRequestSent,
    };
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState, addOnComponent: (data) => NightActionsInfoModal(data) }));
}
